import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Nav, Badge} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const RenewableEnergyPage = () => {
  const [activeTab, setActiveTab] = useState('overview');


  const projects = [
    {
      title: "Solar Grid Integration",
      description: "Advanced AI-powered solar panel management systems for maximum efficiency",
      capacity: "500MW",
      location: "Global Network",
      status: "Active",
      icon: "☀️"
    },
    {
      title: "Wind Farm Optimization",
      description: "Smart wind turbine technology with predictive maintenance algorithms",
      capacity: "750MW",
      location: "Offshore & Onshore",
      status: "Expanding",
      icon: "💨"
    },
    {
      title: "Energy Storage Solutions",
      description: "Next-generation battery systems for renewable energy storage",
      capacity: "200MWh",
      location: "Strategic Locations",
      status: "Development",
      icon: "🔋"
    },
    {
      title: "Hydroelectric Innovation",
      description: "Micro-hydro systems for remote communities and urban applications",
      capacity: "100MW",
      location: "Multi-Regional",
      status: "Pilot Phase",
      icon: "💧"
    }
  ];

  const jobOpenings = [
    {
      role: "Senior Renewable Energy Engineer",
      department: "Engineering",
      location: "Remote/Hybrid",
      type: "Full-time",
      experience: "5+ years",
      description: "Lead the design and implementation of large-scale renewable energy systems"
    },
    {
      role: "Solar Project Manager",
      department: "Project Management",
      location: "Multiple Locations",
      type: "Full-time",
      experience: "3+ years",
      description: "Oversee solar installation projects from conception to completion"
    },
    {
      role: "Wind Energy Analyst",
      department: "Analytics",
      location: "Remote",
      type: "Full-time",
      experience: "2+ years",
      description: "Analyze wind patterns and optimize turbine performance using AI"
    },
    {
      role: "Energy Storage Specialist",
      department: "R&D",
      location: "Tech Hub",
      type: "Full-time",
      experience: "4+ years",
      description: "Develop cutting-edge battery and energy storage technologies"
    },
    {
      role: "Sustainability Consultant",
      department: "Consulting",
      location: "Flexible",
      type: "Contract",
      experience: "3+ years",
      description: "Advise clients on renewable energy transitions and sustainability strategies"
    }
  ];

  const stats = [
    { label: "Clean Energy Generated", value: "2.5", unit: "TWh", icon: "⚡" },
    { label: "CO₂ Emissions Reduced", value: "1.8M", unit: "Tons", icon: "🌱" },
    { label: "Countries Served", value: "45", unit: "+", icon: "🌍" },
    { label: "Active Projects", value: "120", unit: "+", icon: "🚀" }
  ];

  const technologies = [
    {
      name: "AI-Powered Grid Management",
      description: "Machine learning algorithms that optimize energy distribution in real-time",
      impact: "30% efficiency increase"
    },
    {
      name: "Quantum Solar Cells",
      description: "Next-generation photovoltaic technology with enhanced light absorption",
      impact: "45% higher efficiency"
    },
    {
      name: "Smart Wind Prediction",
      description: "Advanced weather modeling for optimal wind energy harvesting",
      impact: "25% output optimization"
    },
    {
      name: "Blockchain Energy Trading",
      description: "Decentralized platform for peer-to-peer renewable energy transactions",
      impact: "Reduced energy costs"
    }
  ];

  const customStyles = `
    .hero-section {
      background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #064e3b 100%);
      color: white;
      padding: 80px 0;
      position: relative;
      overflow: hidden;
    }
    .hero-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(90deg, rgba(16, 185, 129, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%);
      animation: pulse 3s ease-in-out infinite;
    }
    .hero-content {
      position: relative;
      z-index: 2;
    }
    .icon-container {
      width: 80px;
      height: 80px;
      background: rgba(16, 185, 129, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 32px auto;
      border: 1px solid rgba(16, 185, 129, 0.3);
      backdrop-filter: blur(10px);
    }
    .gradient-title {
      background: linear-gradient(90deg, #10b981, #3b82f6);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-size: 4rem;
      font-weight: bold;
    }
    .glass-card {
      background: rgba(255, 255, 255, 0.05);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: all 0.3s ease;
    }
    .glass-card:hover {
      border-color: rgba(16, 185, 129, 0.5);
      transform: translateY(-5px);
    }
    .stat-value {
      color: #10b981;
      font-size: 2rem;
      font-weight: bold;
    }
    .green-text {
      color: #10b981;
    }
    .blue-text {
      color: #3b82f6;
    }
    .purple-text {
      color: #a855f7;
    }
    .yellow-text {
      color: #fbbf24;
    }
    .custom-btn-primary {
      background: linear-gradient(90deg, #10b981, #059669);
      border: none;
      border-radius: 25px;
      padding: 16px 32px;
      font-weight: bold;
      transition: all 0.3s ease;
    }
    .custom-btn-primary:hover {
      transform: scale(1.05);
      background: linear-gradient(90deg, #059669, #047857);
    }
    .custom-btn-outline {
      background: transparent;
      border: 2px solid #10b981;
      border-radius: 25px;
      color: #10b981;
      padding: 16px 32px;
      font-weight: bold;
      transition: all 0.3s ease;
    }
    .custom-btn-outline:hover {
      background: rgba(16, 185, 129, 0.1);
      color: #10b981;
    }
    .custom-nav-tabs .nav-link {
      background: rgba(255, 255, 255, 0.1);
      color: #d1d5db;
      border: none;
      border-radius: 25px;
      margin: 0 8px;
      padding: 12px 24px;
      font-weight: bold;
      transition: all 0.3s ease;
    }
    .custom-nav-tabs .nav-link.active {
      background: #10b981;
      color: white;
      transform: scale(1.05);
    }
    .tech-card {
      background: linear-gradient(90deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.1));
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 16px;
      padding: 32px;
      margin-bottom: 32px;
      transition: all 0.3s ease;
    }
    .tech-card:hover {
      border-color: rgba(16, 185, 129, 0.5);
    }
    .impact-badge {
      background: rgba(16, 185, 129, 0.2);
      color: #10b981;
      padding: 8px 16px;
      border-radius: 25px;
      font-weight: bold;
    }
    .footer-section {
      background: linear-gradient(90deg, rgba(5, 150, 105, 0.5), rgba(30, 58, 138, 0.5));
      backdrop-filter: blur(10px);
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      color: white;
      padding: 64px 0;
    }
    .main-container {
      background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #064e3b 100%);
      min-height: 100vh;
      color: white;
    }
    @keyframes pulse {
      0%, 100% { opacity: 0.5; }
      50% { opacity: 0.8; }
    }
  `;

  const getStatusBadgeVariant = (status) => {
    switch(status) {
      case 'Active': return 'success';
      case 'Expanding': return 'primary';
      case 'Development': return 'warning';
      default: return 'info';
    }
  };

  return (
    <>
      <style>{customStyles}</style>
      <div className="main-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-bg"></div>
          <Container className="hero-content">
            <Row>
              <Col>
                <div className="text-center">
                  <div className="icon-container">
                    <div style={{ fontSize: '2.5rem' }}>🌱</div>
                  </div>
                  <h1 className="gradient-title mb-4">Renewable Energy</h1>
                  <p className="lead mb-5" style={{ color: '#d1d5db', maxWidth: '800px', margin: '0 auto 32px auto' }}>
                    Creating sustainable energy solutions through solar, wind, and innovative clean technologies 
                    to build a greener future for generations to come. Leading the global transition to 100% renewable energy.
                  </p>
                  <div className="d-flex flex-wrap justify-content-center gap-3">
                    <Button className="custom-btn-primary">
                      Explore Projects
                    </Button>
                    <Button className="custom-btn-outline">
                      Join Our Mission
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Stats Section */}
        <Container className="py-5">
          <Row className="g-4">
            {stats.map((stat, index) => (
              <Col key={index} md={6} lg={3}>
                <Card className="glass-card h-100 text-center p-4">
                  <Card.Body>
                    <div style={{ fontSize: '2rem' }} className="mb-3">{stat.icon}</div>
                    <div className="stat-value">
                      {stat.value}<small>{stat.unit}</small>
                    </div>
                    <Card.Text style={{ color: '#d1d5db' }}>{stat.label}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        {/* Navigation Tabs */}
        <Container className="py-4">
          <Nav variant="tabs" className="custom-nav-tabs justify-content-center border-0">
            {['overview', 'projects', 'technology', 'careers'].map((tab) => (
              <Nav.Item key={tab}>
                <Nav.Link 
                  active={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  className="text-capitalize"
                >
                  {tab}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Container>

        {/* Content Sections */}
        <Container className="pb-5">
          {activeTab === 'overview' && (
            <div>
              <h2 className="text-center mb-5 green-text display-4">Our Vision for Tomorrow</h2>
              <Row className="justify-content-center">
                <Col lg={8}>
                  <div className="text-center">
                    <p className="lead mb-5" style={{ color: '#d1d5db' }}>
                      We are pioneering the future of renewable energy through cutting-edge technology and innovative solutions. 
                      Our mission is to accelerate the world's transition to sustainable energy by delivering scalable, 
                      efficient, and cost-effective renewable energy systems that meet the growing global demand.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="g-4 mt-4">
                <Col md={4}>
                  <Card className="glass-card h-100 text-center p-4">
                    <Card.Body>
                      <div style={{ fontSize: '2.5rem' }} className="mb-3">🎯</div>
                      <Card.Title className="green-text">Mission</Card.Title>
                      <Card.Text style={{ color: '#d1d5db' }}>
                        Democratizing clean energy access through innovative technology and sustainable practices.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="glass-card h-100 text-center p-4">
                    <Card.Body>
                      <div style={{ fontSize: '2.5rem' }} className="mb-3">👁️</div>
                      <Card.Title className="blue-text">Vision</Card.Title>
                      <Card.Text style={{ color: '#d1d5db' }}>
                        A world powered entirely by clean, renewable energy sources by 2035.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="glass-card h-100 text-center p-4">
                    <Card.Body>
                      <div style={{ fontSize: '2.5rem' }} className="mb-3">⚡</div>
                      <Card.Title className="purple-text">Impact</Card.Title>
                      <Card.Text style={{ color: '#d1d5db' }}>
                        Reducing global carbon emissions while creating sustainable economic opportunities.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          )}

          {activeTab === 'projects' && (
            <div>
              <h2 className="text-center mb-5 green-text display-4">Active Projects</h2>
              <Row className="g-4">
                {projects.map((project, index) => (
                  <Col key={index} lg={6}>
                    <Card className="glass-card h-100">
                      <Card.Body className="p-4">
                        <div className="d-flex justify-content-between align-items-start mb-4">
                          <div style={{ fontSize: '2.5rem' }}>{project.icon}</div>
                          <Badge bg={getStatusBadgeVariant(project.status)}>
                            {project.status}
                          </Badge>
                        </div>
                        <Card.Title className="green-text h4">{project.title}</Card.Title>
                        <Card.Text style={{ color: '#d1d5db' }} className="mb-4">
                          {project.description}
                        </Card.Text>
                        <Row>
                          <Col>
                            <small style={{ color: '#9ca3af' }}>Capacity</small>
                            <div className="green-text fw-bold">{project.capacity}</div>
                          </Col>
                          <Col>
                            <small style={{ color: '#9ca3af' }}>Location</small>
                            <div className="fw-bold">{project.location}</div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          )}

          {activeTab === 'technology' && (
            <div>
              <h2 className="text-center mb-5 green-text display-4">Cutting-Edge Technologies</h2>
              {technologies.map((tech, index) => (
                <div key={index} className="tech-card">
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                    <h3 className="green-text h4">{tech.name}</h3>
                    <span className="impact-badge">{tech.impact}</span>
                  </div>
                  <p style={{ color: '#d1d5db' }} className="lead">{tech.description}</p>
                </div>
              ))}
              <div className="mt-5">
                <Card className="glass-card text-center p-5">
                  <Card.Body>
                    <h3 className="green-text display-5 mb-4">Innovation Labs</h3>
                    <p className="lead mb-4" style={{ color: '#d1d5db' }}>
                      Our state-of-the-art research facilities are developing the next generation of renewable energy technologies. 
                      From quantum computing applications in energy optimization to advanced materials for solar cells, 
                      we're pushing the boundaries of what's possible in clean energy.
                    </p>
                    <Button className="custom-btn-primary">Explore Research</Button>
                  </Card.Body>
                </Card>
              </div>
            </div>
          )}

          {activeTab === 'careers' && (
            <div>
              <div className="text-center mb-5">
                <h2 className="green-text display-4 mb-4">Join Our Mission</h2>
                <p className="lead" style={{ color: '#d1d5db', maxWidth: '600px', margin: '0 auto' }}>
                  Be part of the renewable energy revolution. We're looking for passionate individuals who want to make a 
                  real impact on the future of sustainable energy. Join our diverse team of engineers, scientists, and 
                  innovators working to solve the world's energy challenges.
                </p>
              </div>

              <Row className="g-4 mb-5">
                {jobOpenings.map((job, index) => (
                  <Col key={index} lg={6}>
                    <Card className="glass-card h-100">
                      <Card.Body className="p-4">
                        <Card.Title className="green-text h5">{job.role}</Card.Title>
                        <div className="mb-3">
                          <Badge bg="primary" className="me-2">{job.department}</Badge>
                          <Badge bg="success">{job.type}</Badge>
                        </div>
                        <Card.Text style={{ color: '#d1d5db' }} className="mb-3">
                          {job.description}
                        </Card.Text>
                        <div className="d-flex justify-content-between small mb-4" style={{ color: '#9ca3af' }}>
                          <span>📍 {job.location}</span>
                          <span>🎯 {job.experience}</span>
                        </div>
                        <Button variant="outline-success" className="w-100">Apply Now</Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>

              <Card className="glass-card text-center p-5">
                <Card.Body>
                  <h3 className="green-text display-5 mb-4">Why Work With Us?</h3>
                  <Row className="g-4">
                    <Col md={4}>
                      <div style={{ fontSize: '2rem' }} className="mb-3">🌟</div>
                      <h4 className="blue-text h5">Innovation Culture</h4>
                      <p style={{ color: '#d1d5db' }}>Work on cutting-edge projects that shape the future of energy</p>
                    </Col>
                    <Col md={4}>
                      <div style={{ fontSize: '2rem' }} className="mb-3">🌍</div>
                      <h4 className="green-text h5">Global Impact</h4>
                      <p style={{ color: '#d1d5db' }}>Make a meaningful difference in combating climate change</p>
                    </Col>
                    <Col md={4}>
                      <div style={{ fontSize: '2rem' }} className="mb-3">🚀</div>
                      <h4 className="purple-text h5">Career Growth</h4>
                      <p style={{ color: '#d1d5db' }}>Continuous learning and advancement opportunities</p>
                    </Col>
                  </Row>
                  <Button className="custom-btn-primary mt-4">View All Positions</Button>
                </Card.Body>
              </Card>
            </div>
          )}
        </Container>

        {/* Footer CTA */}
        <div className="footer-section">
          <Container>
            <Row>
              <Col>
                <div className="text-center">
                  <h2 className="display-4 mb-4 fw-bold">Ready to Power the Future?</h2>
                  <p className="lead mb-5">
                    Join us in creating a sustainable energy future. Whether you're looking to partner with us, 
                    invest in renewable technology, or be part of our team, let's build tomorrow together.
                  </p>
                  <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">
                    <Button className="custom-btn-primary">Get Started</Button>
                    <Button className="custom-btn-outline">Learn More</Button>
                  </div>
                  <Row className="g-4">
                    <Col md={4}>
                      <div style={{ fontSize: '1.5rem' }} className="mb-2">📧</div>
                      <div style={{ color: '#d1d5db' }}>contact@renewableenergy.com</div>
                    </Col>
                    <Col md={4}>
                      <div style={{ fontSize: '1.5rem' }} className="mb-2">📱</div>
                      <div style={{ color: '#d1d5db' }}>+1 (555) 123-4567</div>
                    </Col>
                    <Col md={4}>
                      <div style={{ fontSize: '1.5rem' }} className="mb-2">🌐</div>
                      <div style={{ color: '#d1d5db' }}>Global Headquarters</div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default RenewableEnergyPage;